import 'bootstrap';
// core version + navigation, pagination modules:
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', function (){
    const swiper = new Swiper('.swiper', {

        loop: true,
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 24,
        pagination: {
        el: ".swiper-pagination",
        clickable: true,
        },
        // Responsive
        breakpoints: {
        445: {
            slidesPerView: 2,
            centeredSlides: true,
        },
        991: {
            slidesPerView: 3,
            centeredSlides: true,
            // Navigation
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        },
      },
    });
});


